import './assets/styles/index.scss';
import { Footer } from './components/Footer';
import Home from './containers/Home';

function App() {
  return (
    <div className='App'>
      <Home />
      <Footer />
    </div>
  );
}

export default App;
